import React from 'react';
import BlockInputField from './index';
import ComponentErrorBoundary from '@/Layouts/ComponentErrorBoundary';

const Preview = (props) => (
    <ComponentErrorBoundary componentErrorMessage={props?.componentErrorMessage}>
        <BlockInputField {...props} />
    </ComponentErrorBoundary>
);

export default Preview;
